import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { PrintIcon } from "../../../assets/CommonAssets";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import { getAncWorkSheet } from "../services/EMRServices/emrServices";

export default function ANCWorkSheet(props) {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (props.openWorkSheet === true) {
      getAncWorkSheet(
        props.patientData?.patientId,
        props.parentId !== undefined && props.parentId !== null
          ? props.parentId
          : props.patientData?.visitId,
      ).then((response) => {
        setData(response.data.result);
      });
    }
  }, [props.patientData, props.openWorkSheet]);

  console.log("data7878", props.parentId);

  return (
    <div>
      <Modal
        open={props.openWorkSheet}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "97%",
            height: "97%",
            // maxHeight: "75%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            // overflow: "auto",
            overflowY: "scroll",
            overflowX: "scroll",
          }}
        >
          <div className="text-base font-semibold  mb-4 flex justify-between">
            <div className="-mt-2">
              <CancelPresentationIconButton
                onClick={() => {
                  props.setOpenANCWorkSheet(false);
                }}
              />
            </div>
          </div>
          <div>
            <div className="flex justify-between">
              <div className=" font-semibold flex justify-center items-center p-1">
                ANC WORKSHEET
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  <PrintIcon />
                </button>
              </div>
            </div>

            <table className="border border-gray-300">
              <thead>
                <tr className="space-x-1 bg-customBlue text-white  border-b border-gray-300">
                  <td className="border-r-[1px]  text-center   font-semibold text-[12px] w-16 border-gray-300 p-1">
                    MONTH
                  </td>
                  <td className="border-r  text-center  font-semibold text-[12px] w-16 border-gray-300 p-1">
                    WEEK
                  </td>
                  <td className="border-r text-center  font-semibold text-[12px] w-48 border-gray-300 p-1">
                    DATE
                  </td>
                  <td className="border-r  text-center font-semibold text-[12px] w-16 border-gray-300 p-1">
                    WEIGHT
                  </td>
                  <td className="border-r  text-center font-semibold text-[12px] w-16 border-gray-300 p-1">
                    BP
                  </td>
                  <td className="border-r text-center  font-semibold text-[12px] w-32 border-gray-500 p-1">
                    PULSE
                  </td>

                  <td className="border-r text-center  font-semibold text-[12px] w-32 border-gray-300 p-1">
                    PALLOR
                  </td>
                  <td className="border-r text-center  font-semibold text-[12px] w-32 border-gray-300 p-1">
                    EDEMA
                  </td>
                  <td className="border-r text-center  font-semibold text-[12px] w-32 border-gray-300 p-1">
                    FUNDAL HEI.
                  </td>
                  <td className="border-r text-center  font-semibold text-[12px] w-32 border-gray-300 p-1">
                    FHS
                  </td>
                  <td className="border-r  text-center font-semibold text-[12px] w-32 border-gray-300 p-1">
                    U/A
                  </td>
                  <td className="border-r  text-center font-semibold text-[12px] w-32 border-gray-500 p-1">
                    VAGINAL EX.
                  </td>

                  <td className="border-r text-center  font-semibold text-[12px] w-48 border-gray-300 p-1">
                    IMMUNIZATION
                  </td>
                  <td className="border-r text-center  font-semibold text-[12px] w-48 border-gray-300 p-1">
                    INVESTIGATION
                  </td>
                  <td className="border-r  border-gray-300 text-center w-48 font-semibold text-[12px] p-1">
                    AYURVEDA CONSULTATION
                  </td>
                  <td className="border-r  border-gray-300 text-center w-48 font-semibold text-[12px] p-1">
                    Preventive Measures
                  </td>
                  <td className="border-r  border-gray-300 text-center w-48 font-semibold text-[12px] p-1">
                    Examination
                  </td>
                  <td className="border-r  border-gray-300 text-center w-48 font-semibold text-[12px] p-1">
                    Ahar
                  </td>
                  <td className="border-r  border-gray-300 text-center w-48 font-semibold text-[12px] p-1">
                    Vihar
                  </td>
                  <td className="border-r  border-gray-300 text-center w-48 font-semibold text-[12px] p-1">
                    Activity
                  </td>
                  <td className="border-r  border-gray-300 text-center w-48 font-semibold text-[12px] p-1">
                    Counselling
                  </td>
                </tr>
              </thead>
              <tbody>
                {data?.map((row, index) => {
                  return (
                    <tr className="space-x-1 border-b border-gray-300">
                      <td className="border-r-[1px] font-semibold text-customBlue  text-center   text-[12px] border-gray-300 p-1">
                        {row?.month}
                      </td>
                      <td className="border-r  text-center  text-[12px] border-gray-300 p-1">
                        {row?.week}
                      </td>
                      <td className="border-r text-center  text-[12px] border-gray-300 p-1">
                        {row?.ancDateTime}
                      </td>
                      <td className="border-r  text-center text-[12px] border-gray-300 p-1">
                        {row.weight}
                      </td>
                      <td className="border-r  text-center text-[12px] border-gray-300 p-1">
                        {row.bp}
                      </td>
                      <td className="border-r text-center  text-[12px] border-customBlue p-1">
                        {row.pulse}
                      </td>

                      <td className="border-r text-center  text-[12px] border-gray-300 p-1">
                        {row.pallor}
                      </td>
                      <td className="border-r text-center  text-[12px] border-gray-300 p-1">
                        {row.edema}
                      </td>
                      <td className="border-r text-center  text-[12px] border-gray-300 p-1">
                        {row.fundalHeight}
                      </td>
                      <td className="border-r text-center  text-[12px] border-gray-300 p-1">
                        {row.fhs}
                      </td>
                      <td className="border-r  text-center text-[12px] border-gray-300 p-1">
                        {row?.ua}
                      </td>
                      <td className="border-r  text-center text-[12px] border-customBlue p-1">
                        {row?.vaginalExam}
                      </td>

                      <td className="border-r  text-[12px] border-gray-300 p-1  text-left">
                        {row?.immunizations?.length > 0 &&
                          JSON.parse(row?.immunizations).map((item) => {
                            return <li className="list-none">{item}</li>;
                          })}
                      </td>
                      <td className="border-r   text-[12px] border-gray-300 p-1 text-left ">
                        {row?.investigation?.length > 0 &&
                          JSON.parse(row?.investigation).map((item) => {
                            return <li className="list-none">{item?.test}</li>;
                          })}
                      </td>
                      <td className="border-r  border-gray-300 text-left text-[12px] p-1">
                        {row?.consultationNotes?.length > 0 &&
                          JSON.parse(row?.consultationNotes)?.map(
                            (item, idx) => {
                              return (
                                <div className="flex space-x-1">
                                  {/* <input
                                    type="checkbox"
                                    name={`${index}AyurvedaConsultation${idx}`}
                                  /> */}
                                  <li className="list-none">{item}</li>
                                </div>
                              );
                            },
                          )}
                      </td>
                      <td className="border-r  border-gray-300 text-left text-[12px] p-1">
                        {row?.preventiveMeasures?.length > 0 &&
                          JSON.parse(row?.preventiveMeasures)?.map(
                            (item, idx) => {
                              return (
                                <div className="flex space-x-1">
                                  {/* <input
                                    type="checkbox"
                                    name={`${index}AyurvedaConsultation${idx}`}
                                  /> */}
                                  <li className="list-none">{item?.drugs}</li>
                                </div>
                              );
                            },
                          )}
                      </td>
                      <td className="border-r  text-center text-[12px] border-customBlue p-1">
                        {row?.examination}
                      </td>

                      <td className="border-r  text-[12px] border-gray-300 p-1  text-left">
                        {row?.aharInstructions?.length > 0 &&
                          JSON.parse(row?.aharInstructions).map((item) => {
                            return <li className="list-none">{item}</li>;
                          })}
                      </td>

                      <td className="border-r  text-[12px] border-gray-300 p-1  text-left">
                        {row?.viharInstructions?.length > 0 &&
                          JSON.parse(row?.viharInstructions).map((item) => {
                            return <li className="list-none">{item}</li>;
                          })}
                      </td>
                      <td className="border-r  text-[12px] border-gray-300 p-1  text-left">
                        {row?.activityInstructions?.length > 0 &&
                          JSON.parse(row?.activityInstructions).map((item) => {
                            return <li className="list-none">{item}</li>;
                          })}
                      </td>
                      <td className="border-r  text-[12px] border-gray-300 p-1  text-left">
                        {row?.counsellingInstructions?.length > 0 &&
                          JSON.parse(row?.counsellingInstructions).map(
                            (item) => {
                              return <li className="list-none">{item}</li>;
                            },
                          )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Box>
      </Modal>
      {/* <AncWorkSheetPrint
        open={open}
        parentId={props.parentId}
        setOpen={setOpen}
        patientData={props.patientData}
      /> */}
    </div>
  );
}
